export default class SemanticOverlay {
  constructor(sidebarElement) {
    this.active = false;
    this.sidebar = sidebarElement;
    this.overlay = null;
    this.updateId = null;
    this.cleanup = null;
  }

  enable() {
    if (this.active) return;
    this.active = true;

    const overlay = document.createElement('div');
    overlay.className = 'a11y-semantic-overlay';
    overlay.style.pointerEvents = 'none';
    document.body.appendChild(overlay);
    this.overlay = overlay;
    this.update();

    const scheduleUpdate = () => {
      if (this.updateId) return;
      this.updateId = requestAnimationFrame(() => {
        this.updateId = null;
        this.update();
      });
    };

    window.addEventListener('scroll', scheduleUpdate, true);
    window.addEventListener('resize', scheduleUpdate);
    
    this.cleanup = () => {
      window.removeEventListener('scroll', scheduleUpdate, true);
      window.removeEventListener('resize', scheduleUpdate);
    };
  }

  disable() {
    if (!this.active) return;
    if (this.cleanup) this.cleanup();
    this.overlay?.remove();
    this.overlay = null;
    this.active = false;
  }

  update() {
    if (!this.overlay) return;
    this.overlay.innerHTML = '';
    const selectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'nav', 'main', 'footer', 'header', 'section', 'article', 'aside'];
    const elements = document.querySelectorAll(selectors.join(','));

    elements.forEach((el) => {
      if (this.sidebar.contains(el)) return;
      const rect = el.getBoundingClientRect();
      if (rect.width < 20 || rect.height < 20) return;
      
      const box = document.createElement('div');
      box.className = 'a11y-semantic-box';
      box.dataset.label = el.tagName.toLowerCase();
      box.style.pointerEvents = 'none';
      box.style.left = `${rect.left}px`;
      box.style.top = `${rect.top}px`;
      box.style.width = `${rect.width}px`;
      box.style.height = `${rect.height}px`;
      
      this.overlay.appendChild(box);
    });
  }
}
